
import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    FormGroup,
    Row,
    Col,
    InputGroup,
    InputGroupAddon,
    Input,
    FormFeedback,
    Alert
} from 'reactstrap';

import { connect } from 'react-redux';
import {
    zones__create,
    zones_dismissZoneAlert
} from 'redux/actions/zones'

class ZoneCreator extends Component {
    static propTypes = {
        dispatch: PropTypes.func,
        alert: PropTypes.object
    }

    constructor(props) {
        super(props)
        this.state = {
            section: '',
            telegram: '',
            color: '#000000',
            addzone: false
        }
    }

    createNewZone = () => {
        const { section, telegram, color } = this.state
        if (section === '' || telegram === '' || color === '') {
            return
        }
        let _zone = {
            section: section,
            telegramId: telegram,
            color: color
        }
        const { dispatch } = this.props
        dispatch(zones__create(_zone, '_create'))
    }

    render() {
        const { dispatch, alert } = this.props
        const { _create } = alert
        const { section, telegram, color } = this.state

        let sectionInvalid = false;
        let sectionMsg = '';
        if (_create.id === 'InvalidSection') {
            sectionInvalid = _create.invalid;
            sectionMsg = _create.message
        }

        let telegramInvalid = false;
        let telegramMsg = '';
        if (_create.id === 'InvalidTelegram') {
            telegramInvalid = _create.invalid;
            telegramMsg = _create.message
        }

        let colorInvalid = false;
        let colorMsg = '';
        if (_create.id === 'InvalidColor') {
            colorInvalid = _create.invalid;
            colorMsg = _create.message
        }

        let successAlertOpen = false
        let failAlertOpen = false
        let submitAlertMessage = ''
        if (_create.id !== 'InvalidSection' && _create.id !== 'InvalidTelegram' && _create.id !== 'InvalidColor') {
            if (_create.valid) {
                successAlertOpen = true
            }
            if (_create.invalid) {
                failAlertOpen = true
            }
            submitAlertMessage = _create.message
        }

        return (
            <div>
                <Button onClick={() => { this.setState({ addzone: !this.state.addzone }) }} size="md" color="dark" className="filter-toggler">
                    Add New Zone {' '}<i className="icon-plus"></i>
                </Button>
                <Modal isOpen={this.state.addzone} toggle={() => { this.setState({ addzone: !this.state.addzone }) }} className={'modal-dark'}>
                    <ModalHeader toggle={() => { this.setState({ addzone: !this.state.addzone }) }}><span className="h2">Add New Zone</span></ModalHeader>
                    <ModalBody>
                        <Form onSubmit={(e) => { e.preventDefault() }}>
                            <FormGroup>
                                <Row>
                                    <Col xs='12' className="mt-2">
                                        <InputGroup size='sm'>
                                            <InputGroupAddon addonType="prepend">
                                                Zone :
                                            </InputGroupAddon>
                                            <Input
                                                invalid={sectionInvalid}
                                                value={section}
                                                onChange={(e) => this.setState({ section: e.target.value })}
                                                onFocus={() => dispatch(zones_dismissZoneAlert('', '_create'))}>
                                            </Input>
                                            <FormFeedback
                                                onClick={() => dispatch(zones_dismissZoneAlert('', '_create'))}
                                                valid
                                                className="text-center"
                                                style={{ backgroundColor: 'white' }}>
                                                {sectionMsg}
                                            </FormFeedback>
                                            <FormFeedback
                                                onClick={() => dispatch(zones_dismissZoneAlert('', '_create'))}
                                                className="text-center"
                                                style={{ backgroundColor: 'white' }}>
                                                {sectionMsg}
                                            </FormFeedback>
                                        </InputGroup>
                                    </Col>
                                    <Col xs='12' className="mt-2">
                                        <InputGroup size='sm'>
                                            <InputGroupAddon addonType="prepend">
                                                Telegram ID :
                                            </InputGroupAddon>
                                            <Input
                                                invalid={telegramInvalid}
                                                value={telegram}
                                                onChange={(e) => this.setState({ telegram: e.target.value })}
                                                onFocus={() => dispatch(zones_dismissZoneAlert('', '_create'))}>
                                            </Input>
                                            <FormFeedback
                                                onClick={() => dispatch(zones_dismissZoneAlert('', '_create'))}
                                                valid
                                                className="text-center"
                                                style={{ backgroundColor: 'white' }}>
                                                {telegramMsg}
                                            </FormFeedback>
                                            <FormFeedback
                                                onClick={() => dispatch(zones_dismissZoneAlert('', '_create'))}
                                                className="text-center"
                                                style={{ backgroundColor: 'white' }}>
                                                {telegramMsg}
                                            </FormFeedback>
                                        </InputGroup>
                                    </Col>
                                    <Col xs="12" className="mt-2">
                                        <InputGroup size='sm' className="text-center mx-auto w-50">
                                            <InputGroupAddon addonType="prepend">Color</InputGroupAddon>
                                            <Input
                                                invalid={colorInvalid}
                                                onChange={(e) => this.setState({ color: e.target.value })}
                                                onFocus={() => dispatch(zones_dismissZoneAlert('', '_create'))}
                                                type='color'
                                                value={color}>
                                            </Input>
                                            <FormFeedback
                                                onClick={() => dispatch(zones_dismissZoneAlert('', '_create'))}
                                                valid className="text-center"
                                                style={{ backgroundColor: 'white' }}>
                                                {colorMsg}
                                            </FormFeedback>
                                            <FormFeedback
                                                onClick={() => dispatch(zones_dismissZoneAlert('', '_create'))}
                                                className="text-center"
                                                style={{ backgroundColor: 'white' }}>
                                                {colorMsg}
                                            </FormFeedback>
                                        </InputGroup>
                                    </Col>
                                </Row>
                            </FormGroup>
                            <div className='text-center w-100 my-2'>
                                <Button onClick={this.createNewZone} size='sm' color='primary' className="w-25 mx-auto mb-2">Submit</Button>
                                <div className='w-75 text-center mx-auto'>
                                    <Alert color="success" isOpen={successAlertOpen} toggle={() => dispatch(zones_dismissZoneAlert('', '_create'))}>
                                        {submitAlertMessage}
                                    </Alert>
                                    <Alert color="danger" isOpen={failAlertOpen} toggle={() => dispatch(zones_dismissZoneAlert('', '_create'))}>
                                        {submitAlertMessage}
                                    </Alert>
                                </div>
                            </div>
                        </Form>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (store) => {
    return {
        dispatch: store.dispatch,
        alert: store.zones.alert
    }
}

export default connect(
    mapStateToProps
)(ZoneCreator)


// WEBPACK FOOTER //
// ./src/components/features/ZoneCreator/ZoneCreator.js